<template>
<section>
  <div class="top-container">
    <div class="top-content main-content-wrap">
      <div class="left-container">
        <a href="https://www.vip.com/" target="_blank">
          唯品会首页
        </a>
      </div>
      <div class="right-container">
        <span v-if="isLogin && userInfo.username">
          <a>{{userInfo.username}}</a>
          |
          <a href="javascript:;" @click="loginOut()">退出</a>
        </span>
        <span v-else>
          <a :href="`https://passport.vip.com/login?src=${locationHref}`" title="请登录">请登录</a> |
          <a href="https://passport.vip.com/register" title="注册">注册</a>
        </span>
      </div>
    </div>
  </div>
  <Nav @changeNav="changeNav"></Nav>
  <Search ref="search"></Search>
</section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Nav from './nav.vue'
import Search from './search.vue'
import {mapMutations} from 'vuex'
import {
  clearCookies,
  setCookie,
  getCookie
} from '@/lib'
export default {
  name: '',
  data () {
    return {
      locationHref: encodeURIComponent(window.location.href)
    }
  },
  computed: {
    ...mapState(['userInfo', 'isLogin'])
  },
  beforeMount () {
    setCookie('XSRF-TOKEN', '', -1, 'vip.com')
    setCookie('XSRF-TOKEN', '', -1, 'rule.vip.com')
  },
  mounted () {
    this.$store.dispatch('getUserInfo').catch(() => {
      if (!getCookie('reload')) {
        setCookie('reload', 'true', 1)
        this.loginOut()
      }
    })
    this.$store.dispatch('signIn')
  },
  methods: {
    ...mapMutations('rule', ['updatePhrase']),
    ...mapActions(['signOut']),
    loginOut () {
      clearCookies()
      window.location.href = `https://passport.vip.com/logout?src=${window.encodeURIComponent(window.location.href)}`
    },
    changeNav () {
      this.$refs.search.phrase = ''
      this.updatePhrase('')
    }
  },
  components: {
    Nav,
    Search
  }
}
</script>

<style lang="scss" scoped>
.top-container {
  background: #F5F5F5;
  height: 30px;
  line-height: 30px;
  .top-content  {
    .left-container {
      float: left;
    }
    .right-container {
      float: right;
      a {
        margin-right: 5px;
        margin-left: 5px;
      }
    }
  }
}
</style>
